import { bool } from 'prop-types'
import { connectSortBy } from 'react-instantsearch-dom'
import { compose } from 'redux'

import { withI18n } from 'shared/utils/withI18n'

import SortByDesktop from './SortByDesktop'
import SortByMobile from './SortByMobile'

const SortBy = ({ mobile, ...rest }) => {
  const Component = mobile ? SortByMobile : SortByDesktop

  return (
    <div data-qa-id="sorting-options">
      <Component {...rest} />
    </div>
  )
}

SortBy.propTypes = {
  ...SortByDesktop.propTypes,
  ...SortByMobile.propTypes,
  mobile: bool,
}

SortBy.defaultProps = {
  mobile: false,
}

export default compose(connectSortBy, withI18n())(SortBy)
